import { IDBPDatabase, openDB } from 'idb'

/** Строка индекса: то, что нужно списку «Открыть» без свёртки всей заметки */
export interface INoteIndexRow {
  uuid: string
  title: string
  updatedAt: string | null
  isRemoved: boolean
}

// Индекс заметок пользователя: модуль sync не даёт списка записей набора, поэтому модуль
// ведёт свой, в IndexedDB (своя база на учётную запись), и обновляет при каждой свёртке.
const PREFIX = 'extasy.note.'
const VERSION = 1
const NOTES = 'notes'

type NoteDb = IDBPDatabase<unknown>

const databases = new Map<string, Promise<NoteDb>>()

function database(userUuid: string): Promise<NoteDb> {
  let db = databases.get(userUuid)
  if (!db) {
    db = openDB(`${PREFIX}${userUuid}`, VERSION, {
      upgrade(upgrading) {
        upgrading.createObjectStore(NOTES, { keyPath: 'uuid' })
      },
    })
    databases.set(userUuid, db)
  }
  return db
}

export async function readNoteIndex(userUuid: string): Promise<INoteIndexRow[]> {
  return (await database(userUuid)).getAll(NOTES)
}

export async function writeNoteIndexRow(userUuid: string, row: INoteIndexRow): Promise<void> {
  await (await database(userUuid)).put(NOTES, row)
}

/** Строка заметки, которую клиент больше не показывает: устаревшая, без ключа */
export async function removeNoteIndexRow(userUuid: string, uuid: string): Promise<void> {
  await (await database(userUuid)).delete(NOTES, uuid)
}

/** Забыть открытые базы: после подмены indexedDB в тестах */
export function closeNoteIndex(): void {
  databases.forEach((db) => db.then((opened) => opened.close()).catch(() => undefined))
  databases.clear()
}
